export default __webpack_public_path__ + "static/pattern_cutting-2b6fb16c8d97c38fc3d01c0ece49feb9.png";